import { Injectable } from '@angular/core';
import { HttpBaseService } from '../httpBase/httpBase.service';
import { ENDPOINTS_CONTRACTOR } from '../../constants/ENDPOINTS';
import { Observable } from 'rxjs';
import {
  ReceivedRFPFormItemResponse,
  ReceivedRFPListInsights,
  ReceivedRFPListResponse,
} from '../../models/received-rfp';
import { ApiResponse } from '../../Interfaces/apiResponse.interface';
import { RFPGroup } from '../../models/rfp';

@Injectable({
  providedIn: 'root',
})
export class ReceivedRfpService extends HttpBaseService {
  getAllReceivedRFPs(
    page = 1,
    items_per_page = 25,
    state?: string
  ): Observable<ReceivedRFPListResponse> {
    const url = `${ENDPOINTS_CONTRACTOR.RECEIVED_RFP.GET_RECEIVED_RFP_LIST}?page=${page}&items_per_page=${items_per_page}${state ? '&state=' + state : ''}`;
    return this.get(url);
  }

  getReceivedRFPInsights(): Observable<ApiResponse<ReceivedRFPListInsights>> {
    const url = `${ENDPOINTS_CONTRACTOR.RECEIVED_RFP.GET_RECEIVED_RFP_INSIGHTS}`;
    return this.get(url);
  }

  getReceivedRFPById(id: number): Observable<ReceivedRFPFormItemResponse> {
    const url = `${ENDPOINTS_CONTRACTOR.RECEIVED_RFP.GET_RECEIVED_RFP_BY_ID}/${id}`;
    return this.get(url);
  }

  getReceivedRfpGroups(id: number): Observable<ApiResponse<RFPGroup[]>> {
    const url = `${ENDPOINTS_CONTRACTOR.RECEIVED_RFP.GET_RECEIVED_RFP_GROUPS.replace('{rfp}', String(id))}`;
    return this.get(url);
  }

  declineReceivedRFP(rfpId: number) {
    const url = `${ENDPOINTS_CONTRACTOR.RECEIVED_RFP.POST_DECLINE_RECEIVED_RFP.replace('{rfp}', rfpId.toString())}`;
    return this.post(url, {}, { observe: 'response' });
  }
}
